import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/services/auth/auth.service';

@Component({
  selector: 'baf-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.css']
})
export class StatusBarComponent implements OnInit {
  constructor(private authService: AuthService) {}

  get isAuthenticated() {
    return this.authService.isAuthenticatedValue;
  }

  get userName() {
    return this.authService.userName;
  }

  logout() {
    this.authService.logout();
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/status-bar/status-bar.component.ts